import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { StrategyConfirmationComponent } from './strategy-confirmation.component';
import { ConfirmationSuccessDialogComponent } from './components/confirmation-success-dialog/confirmation-success-dialog.component';
import { BrokersModule } from '@app/modules/trading/modules/profile/components/brokers/brokers.module';


@NgModule({
  declarations: [
    // StrategyConfirmationComponent
  // ConfirmationSuccessDialogComponent
],
  imports: [
    CommonModule,
    // StrategyConfirmationRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    BrokersModule
  ],
  exports: [
    // StrategyConfirmationComponent
  ]
})
export class StrategyConfirmationModule { }
